module.exports = __webpack_public_path__ + "assets/img/34_889.004d6bb8.jpg";